import { storyService } from '../services'

// A bare "YYYY-MM-DD" string parses as UTC midnight in JS (a well-known
// Date gotcha), not local midnight — that silently shifts a story's date by
// a day for anyone west of UTC, and can make "today" comparisons wrong even
// east of UTC. Parse the components ourselves so the date always means
// local midnight, matching how story_data.date is entered/displayed.
const parseDateOnly = (str) => {
  const [y, m, d] = str.split('-').map(Number)
  return new Date(y, m - 1, d)
}

// Contributes date-bearing stories to the surfaces that aggregate other apps' calendar
// items: the landing-page ActivityWidget (upcoming N days, see appDefinition.js's
// calendarEvents/calendarColor and hooks/useActivity.js) and the events calendar (an
// explicit window, which may lie in the past — see helpers/calendarProviders.js). A story
// has only a day-precision date, not a start/end time range, so it's treated as a
// single-day item running from midnight to midnight of that date.
//
// `start`/`end` win when supplied; otherwise the window is [today, today + daysAhead].
// The whole story list is fetched either way (there is no range endpoint) and filtered here.
export const getCalendarEvents = async ({ daysAhead, start, end }) => {
  const res = await storyService.getAll()
  const stories = res.stories || []

  const now = new Date()
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const rangeStart = start ? new Date(start) : todayStart
  const rangeEnd = end ? new Date(end) : new Date(now.getTime() + daysAhead * 24 * 60 * 60 * 1000)

  return stories
    .filter(s => s.story_data && s.story_data.date)
    .map(s => ({ story: s, date: parseDateOnly(s.story_data.date) }))
    .filter(({ date }) => date >= rangeStart && date <= rangeEnd)
    .map(({ story, date }) => ({
      key:   `kayenta_stories:${story.story_slug}`,
      title: story.story_data.topic || story.story_slug,
      start: date.toISOString(),
      end:   date.toISOString(),
      url:   `/kayenta_stories/${story.story_slug}`,
    }))
}
